export function loadMSW() {
  if (process.env.NEXT_PUBLIC_API_MOCKING) {
    const { worker } = require('../../mocks/browser')
    return worker.start()
  }

  return Promise.resolve()
}
